//

const state = {
  activeBroadcast: false,
};

const getters = {
  activeBroadcast: (state) => state.activeBroadcast,
};

const mutations = {
  ACTIVE_BROADCAST: (state, value) => state.activeBroadcast = value,
};

const actions = {
  async showBroadcast({getters, commit, dispatch}, notification){

    if(getters['sidebar/panelId'] === 'notifications') getters.getUserNotifications.unshift(notification);

    dispatch('popups/notifications/displayBroadcastMessage', notification)

    commit('ACTIVE_BROADCAST', true)
    dispatch('createNewDesktopNotification', {
      from: notification.title,
      icon: "",
      body: notification.message,
      tag: notification.id,
      type: notification.type
    })
    dispatch('updateInviteFavicon')
  },
  async hideBroadcast({getters, commit, dispatch}, data) {
    if(getters.activeBroadcast) dispatch('popups/close') //only close popups if broadcast is showing
    commit('ACTIVE_BROADCAST', false)
    dispatch('updateInviteFavicon')
    let desktopNotifications = Object.values(getters.getCurrentDesktopNotifications) || []
    desktopNotifications.forEach(notification => {
      if(notification.title === data.title) dispatch('updateDesktopNotification', {tag: notification.tag})
    })
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
